import type { ReactElement } from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import InsightsIcon from "@mui/icons-material/Insights";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";

interface Step {
  icon: ReactElement;
  step: string;
  title: string;
  description: string;
}

const STEPS: Step[] = [
  {
    icon: <LinkIcon />,
    step: "STEP 1",
    title: "Connect Broker",
    description: "Securely link your Dhan, Zerodha or ICICI Direct account in a few clicks.",
  },
  {
    icon: <InsightsIcon />,
    step: "STEP 2",
    title: "Analyze Markets using AI",
    description: "Let TekStar Invest scan stocks and options for actionable signals.",
  },
  {
    icon: <RocketLaunchIcon />,
    step: "STEP 3",
    title: "Deploy Algo Strategy",
    description: "Choose a strategy and go live directly through your own broker.",
  },
];

export function HowItWorksSection() {
  return (
    <Box sx={{ py: { xs: 10, md: 14 }, bgcolor: "grey.50" }} id="solutions">
      <Container maxWidth="lg">
        <Box textAlign="center" maxWidth={560} mx="auto" mb={8}>
          <Typography variant="h4" fontWeight={800} mb={2}>
            From signup to a running strategy
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Three steps, no coding required.
          </Typography>
        </Box>

        <Grid container spacing={5}>
          {STEPS.map((item) => (
            <Grid item xs={12} md={4} key={item.title} textAlign="center">
              <Box
                sx={{
                  width: 64,
                  height: 64,
                  borderRadius: "50%",
                  bgcolor: "#fff",
                  border: "2px solid",
                  borderColor: "primary.main",
                  color: "primary.main",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mx: "auto",
                  mb: 3,
                }}
              >
                {item.icon}
              </Box>
              <Typography variant="caption" fontWeight={700} color="primary.main">
                {item.step}
              </Typography>
              <Typography variant="h6" fontWeight={700} mb={1}>
                {item.title}
              </Typography>
              <Typography variant="body2" color="text.secondary" maxWidth={280} mx="auto">
                {item.description}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default HowItWorksSection;
